import React from 'react';
import { Button, Container, SearchInput } from '../../../components';
import { IoMdAdd } from 'react-icons/io';
import ProductTable from './ProductTable';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import CreateProduct from './CreateProduct';
import { useProduct } from '../../../context/productContext/ProductContextProvider';

const ProductView = () => {
  const { openModal, closeModal } = useModal();
  const {
    searchQuery,
    setSearchQuery,
    getProductsByPage,
    clearFormData,
    setCurrentPage,
  } = useProduct();
  const handleOpenModal = () => {
    clearFormData();
    openModal(<CreateProduct closeModal={closeModal} />, 'Create Product');
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const onSearchClick = () => {
    setCurrentPage('0');
    getProductsByPage();
  };

  return (
    <Container title="Product">
      <div className="lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3 ">
        <SearchInput
          value={searchQuery}
          onChange={handleSearch}
          onSearchClick={onSearchClick}
        />
        <div className="lg:mt-0 flex justify-center mt-2">
          <Button onClick={handleOpenModal}>
            <div>Add New Product</div>
            <div>
              <IoMdAdd />
            </div>
          </Button>
        </div>
      </div>
      <>
        <ProductTable />
      </>
    </Container>
  );
};

const App = () => (
  <ModalProvider>
    <ProductView />
  </ModalProvider>
);

export default App;

// export default ProductView;
